export default "__VITE_ASSET__DvlecYgd__"